import { IconInterface } from '../interfaces/icon.interface';

const FolderIcon = (props: IconInterface) => {
	const {
		color = '#454545',
		width = 28,
		height = 26,
		strokeWidth = '1.4',
	} = props;

	return (
		<svg
			width={width}
			height={height}
			viewBox="1.3 2.3 13.4 11.4"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M2 4.6A1.6 1.6 0 0 1 3.6 3h2.2l1.4 1.6h5.2A1.6 1.6 0 0 1 14 6.2v5.4A1.6 1.6 0 0 1 12.4 13H3.6A1.6 1.6 0 0 1 2 11.6V4.6Z"
				stroke={color}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
				vectorEffect="non-scaling-stroke"
			/>
		</svg>
	);
};

export default FolderIcon;
